// src/components/FeedbackModal.js
import React, { useState, useEffect } from "react";
import { useApi } from "../apiClient";
import { FaStar } from "react-icons/fa";
import toast from "react-hot-toast";

export default function FeedbackModal({ show, onClose }) {
  const api = useApi();
  const [type, setType] = useState("feedback");
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      setType("feedback");
      setRating(0);
      setHover(0);
      setComment("");
    }
  }, [show]);

  if (!show) return null;

  const submitFeedback = async () => {
    if (type === "feedback" && !rating) {
      toast.error("Please select a rating.");
      return;
    }
    if (!comment.trim()) {
      toast.error("Please enter your feedback or describe the problem.");
      return;
    }
    setSubmitting(true);
    try {
      await api.feedback.submit({ type, rating: type === "feedback" ? rating : null, comment });
      toast.success("Thank you for your feedback!");
      onClose();
    } catch {
      toast.error("Failed to submit. Please try again.");
    }
    setSubmitting(false);
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
      <div className="bg-white rounded-xl p-6 w-full max-w-xs shadow-lg">
        <h3 className="text-lg font-bold mb-3">Feedback / Bug Report</h3>
        <div className="mb-3">
          <label className="block font-semibold mb-1">Type:</label>
          <select
            value={type}
            onChange={e => setType(e.target.value)}
            className="w-full border rounded-xl p-2"
          >
            <option value="feedback">Feedback / Rating</option>
            <option value="bug">Bug Report</option>
            <option value="suggestion">Suggestion</option>
          </select>
        </div>
        {type === "feedback" && (
          <div className="flex gap-1 mb-3 justify-center">
            {[1, 2, 3, 4, 5].map(n => (
              <FaStar
                key={n}
                size={28}
                className={
                  (hover || rating) >= n
                    ? "text-yellow-400 cursor-pointer"
                    : "text-gray-300 cursor-pointer"
                }
                onClick={() => setRating(n)}
                onMouseEnter={() => setHover(n)}
                onMouseLeave={() => setHover(0)}
              />
            ))}
          </div>
        )}
        <textarea
          className="w-full border rounded-xl p-2 mb-3"
          placeholder={
            type === "bug"
              ? "Describe the bug, steps to reproduce, browser/OS, screenshot link (optional)..."
              : type === "suggestion"
              ? "Share your idea for improvement..."
              : "Leave a comment (optional)"
          }
          value={comment}
          onChange={e => setComment(e.target.value)}
          rows={type === "bug" ? 4 : 2}
        />
        <div className="flex justify-end gap-2">
          <button
            className="px-4 py-2 rounded-xl bg-gray-100 text-gray-700"
            onClick={onClose}
            disabled={submitting}
          >Cancel</button>
          <button
            className="px-4 py-2 rounded-xl bg-blue-500 text-white font-bold"
            onClick={submitFeedback}
            disabled={submitting}
          >Submit</button>
        </div>
      </div>
    </div>
  );
}